<template>
    <div>
        <div class="row justify-content-between mb-0">
            <div class="col-auto d-flex align-items-center">
                <h3 class="mb-0">New Order</h3>
            </div>
            <div class="col-auto d-flex align-items-center">
                <button class="btn btn-light mx-2" type="button" @click="saveOrder">Save Draft</button>
                <button class="btn btn-primary" type="button">Continue</button>
            </div>
        </div>
        <hr class="mt-2">
        <div  class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">
                        <span class="lead">Select Products</span>
                    </div>
                    <div class="card-body">
                        <!-- <div class="row px-3 w-100">
                            Products
                        </div> -->
                        <div class="row justify-content-between">
                         
                            <div class="input-group mb-2">
                              <input type="text" v-model="pagination.searchparams.search" class="form-control" style="background-color:#fff" placeholder="Search..." @keyup.enter="runSearch" :readonly="loading"/>
                          
                                <span v-if="!search_params_changed">
                                  <button v-if="!loading" type="button" class="btn btn-outline-secondary  btn-search" @click="runSearch"><i class="fa fa-search"></i></button>
                                
                                  <button v-else type="button" class="btn btn-outline-secondary btn-search" disabled><i class="fa fa-spinner fa-spin"></i></button>
                                </span>
                                <span v-else>
                                  <button type="button" class="btn btn-primary btn-search" @click="search_params_changed = false; runSearch();"><i class="fa fa-search"></i> Apply Updated Filters</button>
                                </span> &nbsp &nbsp <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
                                 
                            </div>


                       
                        </div>
                        <div class="row">
                            <div class="col">


                            <ul class="nav justify-content-between mb-2">
                                  <li class="nav-item">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text">Category</span>
                                        <select v-model="pagination.searchparams.type" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                          <option value="">All</option>
                                          <option value="Apparel">Apparel</option>
                                          <option value="Bag">Bag</option>
                                          <option value="Board">Board</option>
                                          <option value="Bundle">Bundle</option>
                                          <option value="Fins">Fins</option>
                                          <option value="Rope">Rope</option>
                                        </select>
                                      </div>
                                  </li>
                                  <li class="nav-item">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text">Style</span>
                                        <select v-model="pagination.searchparams.style" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                          <option value="">All</option>
                                          <option value="Compression">Compression</option>
                                          <option value="EPS">EPS</option>
                                          <option value="Garage">Garage</option>
                                        </select>
                                      </div>
                                  </li>
                                  <li class="nav-item">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text">Model</span>
                                        <select v-model="pagination.searchparams.model" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                          <option value="">All</option>
                                          <option value="El Jefe">El Jefe</option>
                                          <option value="Falcon">Falcon</option>
                                          <option value="Helio">Helio</option>
                                          <option value="Hydro">Hydro</option>
                                          <option value="Lithium">Lithium</option>
                                          <option value="Mongrel">Mongrel</option>
                                          <option value="Neo">Neo</option>
                                          <option value="Nitro">Nitro</option>
                                          <option value="Nubsep">Nubsep</option>
                                          <option value="Nubsep">Nubstep</option>
                                        </select>
                                      </div>
                                  </li>
                                  <li class="nav-item">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text">Size</span>
                                        <select v-model="pagination.searchparams.size" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                          <option value="">All</option>
                                          <option value="38">3'-8"</option>
                                          <option value="42">4'-2"</option>
                                          <option value="44">4'-4"</option>
                                          <option value="46">4'-6"</option>
                                          <option value="48">4'-8"</option>
                                          <option value="410">4'-10"</option>
                                          <option value="50">5'-0"</option>
                                          <option value="52">5'-2"</option>
                                          <option value="56">5'-6"</option>
                                          <option value="410">4'-10"</option>
                                        </select>
                                      </div>
                                  </li>
                                  <li class="nav-item">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text">Color</span>
                                        <select v-model="pagination.searchparams.color" class="form-select" style="background-color:#fff" @change="search_params_changed = true" :disabled="loading">
                                          <option value="">All</option>
                                          <option value="Bamboo">Bamboo</option>
                                          <option value="Black">Black</option>
                                          <option value="Blue">Blue</option>
                                          <option value="Burnt">Burnt</option>
                                          <option value="Gold">Gold</option>
                                          <option value="Green">Green</option>
                                          <option value="Grey">Grey</option>
                                          <option value="Pink">Pink</option>
                                          <option value="Orange">Orange</option>
                                          <option value="Kevlar">Kevlar</option>
                                          <option value="Red">Red</option>
                                          <option value="Space">Space</option>
                                          <option value="Yellow">Yellow</option>
                                          <option value="White">White</option>
                                        </select>
                                      </div>
                                  </li>
                                </ul>
                            </div>
                        </div>







<!-- <Transition> -->
                        <div v-if="!product_selected">
                            
                            <div class="order-wrapper mt-2" v-if="pagination.data.length > 0">
                                <div class="order-table px-0 mx-0 my-0" >
                                    <div class="order-tr order-th sticky-top">
                                        <div class="order-td order-img-col"></div>
                                        <div class="order-td order-sku-col">SKU</div>
                                        <div class="order-td order-name-col">Description</div>
                                        <div class="order-td order-price-col">Wholesale Price</div>
                                        <div class="order-td order-price-col">US Retail MAP</div>
                                        
                                        <!-- <div class="order-td">Quantity</div>
                                        <div class="order-td">Total</div> -->
                                    </div>
                                    <div class="order-tr" v-for="product in products" :key="product.id" style="cursor: pointer;" @click="setActiveProduct(product)">
                                        
                                        <div class="order-td position-relative order-img-col"><img class="img-thumbnail" :alt="product.name" :src="product.image_url" crossorigin="anonymous" @error="product.image_url='/imgs/doomswell-placeholder.png'"/> 
                                        <span v-if="product.quantity_orderable === 0" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-danger">
                                            out of stock
                                        </span>
                                        <span v-if="product.quantity_available === 0 && product.quantity_incoming > 0" class="position-absolute bottom-0 start-50 translate-middle badge rounded-pill bg-success">
                                            preorder
                                        </span>
                                    </div>
                                        <div class="order-td order-sku-col">{{ product.sku }}</div>
                                        <div class="order-td order-name-col">{{ product.name }}</div> 
                                        <div class="order-td order-price-col fw-bold">{{ product.sale_price | currency }}</div>
                                        <div class="order-td order-price-col">{{ product.retail_price | currency }}</div>
                                        
                                        <!-- <div class="order-td"></div>
                                        <div class="order-td"></div> -->
                                    
                                    </div>
                                </div>
                                
                            </div>
                            <div v-else v-show="!loading" class="row justify-content-center">
                                <div class="row justify-content-center pt-3 pb-2">
                                  No products matching search criteria found
                              </div>
                                  
                              <div class="row justify-content-center col-auto">
                                  <button class="btn btn-outline-danger btn-reset pull-right" style="border-radius: 0.375rem;" type="button" role="button" @click="resetSearch">Reset</button>
                              </div>
                            </div>
                        
                        </div>
                        <div v-else class="row mb-2">
                            <div class="col-12">
                                <hr class="mt-3">
                                <div id="selectedProduct" class="form-select form-select-lg mt-4" @click="product_selected = false" style="cursor: pointer;">{{ selected_product.name }}</div>
                            </div>
                        </div>
                        <!-- </Transition> -->
                            <div v-if="selected_product.length != 0" class="order-item-config">
                                <div class="row justify-content-start py-2">
                                    <div class="col-auto ">Product Details</div><hr  class="col" style="margin-top:12px;margin-right:12px;">
                                </div>
                                <div class="row justify-content-start">
                                    <!-- <div class="col-md-2" v-show="selected_product.sku">
                                        <label for="selectedProductSku" class="form-label text-muted mb-0">SKU</label>
                                        <input type="text" readonly class="form-control-plaintext" id="selectedProductSku" :value="selected_product.sku">
                                    </div> -->
                                    <div class="col-md-2" v-show="selected_product.type">
                                        <label for="selectedProductCategory" class="form-label text-muted mb-0"><small>Category</small></label>
                                        <input type="text" readonly class="form-control-plaintext" id="selectedProductCategory" :value="selected_product.type">
                                    </div>
                                    <div class="col-md-2" v-show="selected_product.model">
                                        <label for="selectedProductModel" class="form-label text-muted mb-0"><small>Model</small></label>
                                        <input type="text" readonly class="form-control-plaintext" id="selectedProductModel" :value="selected_product.model">
                                    </div>
                                    <div class="col-md-2" v-show="selected_product.size">
                                        <label for="selectedProductSize" class="form-label text-muted mb-0"><small>Size</small></label>
                                        <input type="text" readonly class="form-control-plaintext" id="selectedProductSize" :value="selected_product.size">
                                    </div>
                                    <div class="col-md-2" v-show="selected_product.style">
                                        <label for="selectedProductStyle" class="form-label text-muted mb-0"><small>Style</small></label>
                                        <input type="text" readonly class="form-control-plaintext" id="selectedProductStyle" :value="selected_product.style">
                                    </div>
                                    <div class="col-md-2" v-show="selected_product.color">
                                        <label for="selectedProductColor" class="form-label text-muted mb-0"><small>Color</small></label>
                                        <input type="text" readonly class="form-control-plaintext" id="selectedProductColor" :value="selected_product.color">
                                    </div>
                                </div>

                                <div class="row justify-content-start py-2">
                                    <div class="col-auto ">Order Quantity</div>
                                    <hr  class="col" style="margin-top:12px;margin-right:12px;">
                                </div>
                                <div class="row d-flex justify-content-center g-1 px-3 py-2">
                                    <div class="card text-dark " style="background-color:#e3eeff;">
                                        <div class="card-body px-0">
                                            <div class="row d-flex justify-content-evenly">
                                            <!-- <div class="col-md-2">
                                                <label for="selectedProductSKU" class="form-label text-muted mb-0"><small>SKU</small></label>
                                                <input type="text" readonly class="form-control-plaintext" id="selectedProductSKU" :value="selected_product.sku">
                                            </div> -->
                                            
                                        
                                            <div v-if="!new_order.multi_ship"class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Quantity</small></label>
                                                <input v-model="new_item.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="maxItemQuantity">
                                            </div>
                                            <div v-if="new_order.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="shipOneQuantity" class="form-label text-muted mb-0"><small>Ship 1</small></label>
                                                <input v-model="new_item.ship_one.quantity" type="number" class="form-control text-center" id="shipOneQuantity" name="ship1" min="0" :max="maxShipOneItemQuantity">
                                            </div>
                                            <div v-if="new_order.multi_ship" class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="shipTwoQuantity" class="form-label text-muted mb-0"><small>Ship 2</small></label>
                                                <input v-model="new_item.ship_two.quantity" type="number" class="form-control text-center" id="shipTwoQuantity" name="ship2" min="0" :max="maxShipTwoItemQuantity">
                                            </div>
                                            <div v-if="new_order.multi_ship" class="col-md-2 text-center"  style="max-width:125px;">
                                                <label for="totalQuantity" class="form-label text-muted mb-0"><small>Total Quantity</small></label>
                                                <input type="text" readonly class="form-control-plaintext text-center" id="totalQuantity" :value="new_item.total_quantity">
                                            </div>
                                            <div class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="selectedProductWholesale" class="form-label text-muted mb-0"><small>Wholesale</small></label>
                                                <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesale" :value="selected_product.sale_price|currency">
                                            </div>
                                            <div class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="selectedProductWholesaleMargin" class="form-label text-muted mb-0"><small>Margin</small></label>
                                                <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductWholesaleMargin" value="45%">
                                            </div>
                                            <div class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="selectedProductRetail" class="form-label text-muted mb-0"><small>MAP</small></label>
                                                <input type="text" readonly class="form-control-plaintext text-center" id="selectedProductRetail" :value="selected_product.retail_price|currency">
                                            </div>
                                            <div class="col-md-2 text-center" style="max-width:100px;">
                                                <label for="totalCost" class="form-label text-muted mb-0"><small class="fw-bold">Item Total</small></label>
                                                <input type="text" class="form-control-plaintext text-center fw-bold" id="totalCost" :value="new_item.total_cost|currency">
                                            </div>

                                         
                                            <!-- <div class="col-md-2" v-show="selected_product.sale_price">
                                                <label for="selectedProductRetail" class="form-label text-muted mb-0"><small>Retail MAP</small></label>
                                                <input type="text" readonly class="form-control-plaintext" id="selectedProductRetail" :value="selected_product.retail_price|currency">
                                            </div> -->
                                            <div class="row d-flex justify-content-end mt-3">
                                                <div class="col-auto">
                                                <button class="btn btn-light float-right" type="button" @click="cancelOrderItem">Cancel</button>
                                                <button :disabled="new_item.total_cost == 0" class="btn btn-primary float-right" type="button" @click="addItemToOrder">Add To Order</button>
                                            </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                    <!-- <div class="quantity-wrapper" v-if="pagination.data.length > 0">
                                        <div class="quantity-table px-0 mx-0 my-0" >
                                            <div class="quantity-tr order-th sticky-top">
                                                <div class="order-td order-img-col"></div>
                                                <div class="order-td order-sku-col">SKU</div>
                                                <div class="order-td order-name-col">Description</div>
                                                <div class="order-td order-price-col">US Retail MAP</div>
                                                <div class="order-td order-price-col">Wholesale Price</div>
                                         
                                            </div>
                                            <div class="quantity-tr">
                                                
                                                <div class="order-td order-img-col"><img class="img-thumbnail" :alt="product.name" :src="product.image_url" crossorigin="anonymous" @error="product.image_url='/imgs/doomswell-placeholder.png'"/> </div>
                                                <div class="order-td order-sku-col">{{ product.sku }}</div>
                                                <div class="order-td order-name-col">{{ product.name }}</div> 
                                                <div class="order-td order-price-col">{{ product.retail_price | currency }}</div>
                                                <div class="order-td order-price-col">{{ product.sale_price | currency }}</div>
                                               
                                            
                                            </div>
                                        </div>
                                        
                                    </div> -->

                                </div>
                                    

                            
                            </div>







                        <!-- <div class="card px-3 w-100" style="max-height:400px;overflow:auto;">
                           <div class="row d-flex align-items-center border-bottom" style="min-height:75px;"v-for="product in products">
                            <div class="col-2">
                                <img style="max-height:50px;" :src="product.image_url" crossorigin="anonymous" /> 
                            </div>
                            <div class="col-auto">
                                <span class="align-middle">{{ product.name }}</span>
                            </div>
                           </div>
                        </div> -->


                    </div>

                </div>
            </div>
            <div class="col-md-4">
                <!-- <div class="row"> -->
                    <div class="card" style="font-size:1rem;">
                        <div class="card-header">
                            <span class="lead">Order Options</span>
                        </div>
                        <div class="card-body">
                            <div class="row mt-2">
                                <div class="col w-100">
                                    <label for="orderCompany" class="form-label">Company</label>
                                    <select v-model="selected_contact" id="orderCompany" class="form-select" aria-label="Company selection">
                                        <option v-for="contact in contacts" :key="contact.id" v-bind:value="contact">
                                          {{ contact.company_name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <hr>
                            <div class="row mt-2">
                                <div class="col w-100">
                                    <span v-if="!new_order.multi_ship">Split Shipments: &nbsp <i type="button" role="button" class="fa fa-toggle-off" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                                    <span v-else>Split Shipments: &nbsp <i type="button" role="button" class="fa fa-toggle-on text-success" aria-hidden="true" @click="toggleSplitShipments"></i></span>
                                </div>
                            </div>

                            <div class="row pt-2 mt-2">
                                <div class="col w-100">
                                    <label for="shipOne" class="form-label">Ship Date</label>
                                    <input type="date" class="form-control" id="shipOne" :value="new_order.ship_date_one" :min="min_ship_date" :max="max_ship_date">
                                </div>
                            </div>
                            <div class="row pt-2 mt-2" v-if="new_order.multi_ship">
                                <div class="col w-100">
                                    <label for="shipTwo" class="form-label">Ship Date Two</label>
                                    <input type="date" class="form-control" id="shipTwo" :value="new_order.ship_date_two" :min="min_ship_date" :max="max_ship_date">
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- </div>
                <div class="row col"> -->
                    <div class="card w-100 mt-3">
                        <div class="card-header">
                            <span class="lead">Order Details</span>
                        </div>
                        <div class="card-body" v-if="new_order.items.length != 0">

                            <div class="line-item-table px-0 mx-0 my-0" >

                                    <div class="line-item-tr" v-for="item in new_order.items" :key="item.id">
                                        
                                        <div class="line-item-td line-item-img-col">
                                            <div class="position-relative">
                                                <img class="img-thumbnail" :alt="item.name" :src="item.image_url" crossorigin="anonymous" @error="item.image_url='/imgs/doomswell-placeholder.png'"/>
                                                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                    {{ item.total_quantity }}
                                                    <!-- <span class="visually-hidden">unread messages</span> -->
                                                </span>
                                            </div>
                                        </div>
                                        <div class="line-item-td line-item-meta-col pl-2">
                                            <!-- <div class="line-item-child-table px-0 mx-0 my-0" >
                                                <div class="line-item-child-tr">
                                                    <div class="line-item-child-td"> -->
                                                        <span class="fw-bold">{{ item.name }}</span>
                                               <!--      </div>
                                                </div>

                                            </div> -->
                                        </div>
                                        <div class="line-item-td line-item-cost-col">
                                            
                                               
                                                    <span class="fw-bold">{{ item.total_cost | currency }}</span>
                                                

                                         
                                        </div> 
                                        
                                    
                                    </div>
                                    <div class="line-item-tr">
                                        <div class="line-item-td justify-content-start" style="max-width:75px;">
                                            <h3>Total</h3>
                                        </div>
                                        <div class="line-item-td justify-content-end">
                                            <span class="text-muted"><s>{{ (new_order.total_cost / 0.55) | currency }}</s>&nbsp</span>
                                            <h3>{{ new_order.total_cost | currency }}</h3>
                                        </div>
                                    </div>
                                </div>












                            <!-- {{ new_order.items }} -->
                        </div>
                        <div class="card-body" v-else>
                            Click to add an item
                        </div>
                    </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<style lang="css" scoped>
    .v-enter-active,
    .v-leave-active {
      transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
      opacity: 0;
    }

    .btn-light {
    background-color: white;
    /*border-color: #49545a;*/
    border: 1px solid #b0b9bf;
  }

  .btn-light:hover, .btn-light:active, .btn-light:focus {
    background-color: #dde1e3;
  }

    .btn-search {
        border-radius: 0rem .25rem .25rem 0rem;
      }

      .btn-reset {
        border-top-left-radius: 0.375rem;
      }

    .order-item-config {
        font-size: 1rem;
    }
    .card-header {
        background-color:  #fff;
    }

    .order-wrapper {
        border: var(--bs-card-border-width) solid var(--bs-card-border-color);
        border-radius: var(--bs-card-border-radius);

        width: 100%;
        max-height:400px;
        overflow-x:auto;
        overflow-y:scroll;
    }

     /*@media (min-width: 1400) {
        .order-wrapper {
          overflow-x: hidden;
        }
      }*/


    .order-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 1.5;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .order-table > .order-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .order-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .order-th > .order-td {
        white-space: normal;
    }

      .order-tr {
        min-width: 800px;
        display: flex;
        flex-flow: row nowrap;

    }

    

     .order-tr:nth-of-type(even) {
        background-color: #f8fafc;
    }

    .order-tr:nth-of-type(odd) {
        background-color: #ffffff;
    }

    .order-tr:hover {
        background-color: #f2f2f2;
    }

    .order-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        border-bottom: 1px solid #d0d0d0;
        align-items: center;
    }

    .order-img-col {
        min-width: 100px;
        justify-content: center;
    }

    .order-sku-col {
        min-width: 180px;
        justify-content: center;
    }

    .order-name-col {
        min-width: 240px;
        justify-content: center;
    }

    .order-price-col {
        min-width: 140px;
        justify-content: center;
    }



    .line-item-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 2;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .line-item-table > .line-item-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .line-item-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .line-item-th > .line-item-td {
        white-space: normal;
    }

      .line-item-tr {
        /*min-width: 800px;*/
        display: flex;
        flex-flow: row nowrap;
        border-bottom: 1px solid #d0d0d0;
        padding-top: 10px;
        padding-bottom: 10px;

    }

    .line-item-tr:first-of-type {
        padding-top: 0px;
    }

    .line-item-tr:last-of-type {
        border-bottom: none;
        padding-bottom:  0px;
    }



    .line-item-tr:hover {
        background-color: #f2f2f2;
    }

    .line-item-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        
        align-items: center;
    }

    

    .line-item-img-col {
        max-width: 75px;
        min-width: 75px;
        justify-content: start;
    }

    .line-item-meta-col {
        font-weight: 500;
        min-width: 207px;
        justify-content: start;
    }

    .line-item-cost-col {
        min-width: 100px;
        justify-content: end;
    }

    .line-item-child-table {
      display: flex;
      flex-flow: column nowrap;
      font-size: 1rem;
      line-height: 1.5;
      flex: 1 1 auto;
    }

    .line-item-child-table > .line-item-child-tr {
      display: flex;
      flex-wrap: nowrap;
      /*min-height: 53.5px;*/
    }

    .line-item-child-td {
      display: flex;
      flex-flow: row nowrap;
      flex-grow: 1;
      flex-basis: 0;
      padding: 0.5em;
      word-break: break-word;
      min-width: 0px;
      /*justify-content: center;*/
      align-items: center;
    }




</style>

<script>
// import 'qs';
const qs = require('qs');
// import qs from 'qs';

import moment from 'moment'
  export default {
   props:[],
    data() {
      return {
        pagination: {
          "current_page": 1,
          "data": [],
          "first_page_url": null,
          "from": null,
          "last_page": null,
          "last_page_url": null,
          "next_page_url": null,
          "path": null,
          "prev_page_url": null,
          "to": null,
          "total": null,
          "has_more_pages": false,
          "per_page": 1000,
          "contacts": [],
          "searchparams": {
            "search": "",
            "sortby": "sku",
            "order": "asc",
            "type": "",
            "style": "",
            "model": "",
            "color": "",
            "size": "",
            "in_stock_only": ""
          },
        },
        data_endpoint: "/api/orders/products",
        search_params_changed: false,
        products: [],
        contacts: [],
        loading: false,
        fetched_products: false,
        selected_product: [],
        selected_contact: [],
        product_selected: false,
        min_ship_date: null,
        max_ship_date: null,
        saved: false,
        new_order: {
            "contact_id": 0, 
            "order_number": "TEST-1234",
            "multi_ship": false,
            "contains_preorder": false,
            "sync_status": "draft",
            "total_cost": 0,
            "ship_date_one": null,
            "ship_date_two": null,
            "items":[]
        },
        new_item: {
            "id": null,
            "sku": null,
            "name": null,
            "image_url": null,
            "preorder": false,
            "unit_price": 0,
            "total_quantity": 0,
            "total_cost": 0,
            "ship_one": {
                "quantity": 0,
                "cost": 0,
                "preorder": false,
            },
            "ship_two": {
                "quantity": 0,
                "cost": 0,
                "preorder": false,
            }
        },
    };
    },
    created() {
      // runs when the component is created
      this.setDefaultDates();
      this.fetchData();
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
        shipDateTwo(){
            if (this.new_order.multi_ship)
            {
                this.new_order.ship_date_two = moment().add(1, 'M').format("YYYY-MM-DD");
            } else {
                this.new_order.ship_date_two = null;
            }
        },
        maxItemQuantity(){
            if (this.selected_product.length != 0)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available;
            } else {
                return 0;
            }
        },
        maxShipOneItemQuantity(){
            if (this.selected_product.length != 0)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available - this.new_item.ship_two.quantity;
            } else {
                return 0;
            }
        },
        maxShipTwoItemQuantity(){
            if (this.selected_product.length != 0)
            {
                let available = this.selected_product.quantity_available + this.selected_product.quantity_incoming;

                return available - this.new_item.ship_one.quantity;
            } else {
                return 0;
            }
        },
        newItemTotals(){
            if (this.selected_product.length != 0)
            {
                this.new_item.ship_one.cost = this.new_item.ship_one.quantity * this.new_item.unit_price;
                this.new_item.ship_two.cost = this.new_item.ship_two.quantity * this.new_item.unit_price;
                this.new_item.total_quantity = +this.new_item.ship_one.quantity + +this.new_item.ship_two.quantity;
                this.new_item.total_cost = (this.new_item.ship_one.quantity * this.new_item.unit_price) + (this.new_item.ship_two.quantity * this.new_item.unit_price);

                if (this.selected_product.quantity_available == 0 && this.selected_product.quantity_incoming > 0)
                {
                    this.new_item.preorder = true;
                }
                

            }

            if (this.new_order.items.length != 0)
            {
                let total = 0;
                this.new_order.items.forEach((item) => {
                    total = +item.total_cost + total;
                });

                this.new_order.total_cost = total;
            }
        }
        // shipTwoMaxItemQuantity(){
        //     if (this.selected_product.length != 0)
        //     {
        // }

    },
    methods: {
        toggleSplitShipments(){
            this.new_order.multi_ship = !this.new_order.multi_ship;

            if (!this.new_order.multi_ship)
            {
                this.new_item.ship_two.quantity = 0;
                this.new_item.ship_two.cost = 0;
                this.new_item.ship_two.preorder = false;
            }
        },
        addItemToOrder(){

            const line_item = structuredClone(this.new_item);

            if (line_item.preorder == true)
            {
                this.new_order.contains_preorder = true;
            }

            this.new_order.items.push(line_item);

            this.product_selected = false;
            this.selected_product = [];

            this.new_item.id = null;
            this.new_item.sku = null;
            this.new_item.name = null;
            this.new_item.image_url = null;
            this.new_item.unit_price = 0;
            this.new_item.total_cost = 0;
            this.new_item.preorder = false;
            this.new_item.ship_one.quantity = 0;
            this.new_item.ship_one.cost = 0;
            this.new_item.ship_one.preorder = false;
            this.new_item.ship_two.quantity = 0;
            this.new_item.ship_two.cost = 0;
            this.new_item.ship_two.preorder = false;

           

        },
        cancelOrderItem(){
            this.product_selected = false;
            this.selected_product = [];
            this.resetOrderItem();
        },
        resetOrderItem(){
            this.new_item.id = null;
            this.new_item.sku = null;
            this.new_item.name = null;
            this.new_item.image_url = null;
            this.new_item.unit_price = 0;
            this.new_item.total_cost = 0;
            this.new_item.preorder = false;
            this.new_item.ship_one.quantity = 0;
            this.new_item.ship_one.cost = 0;
            this.new_item.ship_two.preorder = false;
            this.new_item.ship_two.quantity = 0;
            this.new_item.ship_two.cost = 0;
            this.new_item.ship_two.preorder = false;

        },
        setDefaultDates(){
            this.new_order.ship_date_one = moment().add(1, 'd').format("YYYY-MM-DD");
            this.new_order.ship_date_two = null;
            this.min_ship_date = moment().add(1, 'd').format("YYYY-MM-DD");
            this.max_ship_date = moment().add(1, 'Y').format("YYYY-MM-DD");
        },
      fetchData(){
        this.fetchProducts(this.pagination.searchparams);
      },

      fetchProducts(params, page = 1) {
        this.loading = true;
        params.page = page;
        params.per_page = this.pagination.per_page;
        axios.get(this.data_endpoint, {
                params: params,
                paramsSerializer: function(params) {
                    return qs.stringify(params)
                },

          }).then((res) => {
            this.pagination = res.data;
            this.products = res.data.data;
            this.contacts = res.data.contacts;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_products = true;
            this.loading = false;
            return true;
          });
      },
      nextPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page + 1);
      },
      prevPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.current_page - 1);
      },
      firstPage(){
        this.fetchProducts(this.pagination.searchparams, 1);
      },
      lastPage(){
        this.fetchProducts(this.pagination.searchparams, this.pagination.last_page);
      },
      runSearch() {
        this.fetchProducts(this.pagination.searchparams);
        this.search_params_changed = false;
      },
      setActiveProduct(product) {

            if (this.selected_product.length != 0)
            {
                this.resetOrderItem();
            }
            this.selected_product = product;
            this.product_selected = true;
            this.new_item.id = product.id;
            this.new_item.sku = product.sku;
            this.new_item.image_url = product.image_url;
            this.new_item.name = product.name;
            this.new_item.unit_price = product.sale_price;
        },
        resetSearch()
        {
            this.pagination.first_page_url = null;
          this.pagination.from = null;
          this.pagination.last_page = null;
          this.pagination.last_page_url = null;
          this.pagination.next_page_url = null;
          this.pagination.path = null;
          this.pagination.prev_page_url = null;
          this.pagination.to = null;
          this.pagination.total = null;
          this.pagination.has_more_pages = false;
          this.pagination.per_page = 1000;
      
            this.pagination.searchparams.search = '';
            this.pagination.searchparams.sortby = 'sku';
            this.pagination.searchparams.order = 'asc';
            this.pagination.searchparams.type = '';
            this.pagination.searchparams.style = '';
            this.pagination.searchparams.model = '';
            this.pagination.searchparams.color = '';
            this.pagination.searchparams.size = '';
            this.pagination.searchparams.in_stock_only = '';
        
            this.runSearch();
        },
        saveDraft(){

            if (!this.saved)
            {
                this.saveOrder();
            }
        },
        saveOrder(){
            axios({
              method: 'post',
              url: '/api/orders/order',
              data: this.new_order,
            }).then((res)=>{
                this.saved = true;
                // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
            }).catch((error) => {
              console.log(error);
              // this.errors.push({msg: error.response.data.message });
              // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
            });
        },
        updateOrder(){
            axios({
              method: 'put',
              url: '/api/orders/order',
              data: this.new_order,
            }).then((res)=>{
                this.saved = true;
                // Bus.$emit('newOacAlert', {text: 'Thank you for requesting a new feature!', type: 'success'});
            }).catch((error) => {
              console.log(error);
              // this.errors.push({msg: error.response.data.message });
              // Bus.$emit('newOacAlert', {text: error.response.data.message, type: 'danger'});
            });
        },

    },
    filters: {
        moment: function (date) {
            return moment(date).format('MM/DD/YYYY, h:mm a');
        }
    },
    watch: {
      search_params_changed: function (newItem, oldItem) {
        this.runSearch();
      },
      selected_contact: function (newItem, oldItem) {
        if (this.selected_contact.length != 0)
        {
            this.new_order.contact_id = this.selected_contact.id;
        }
      },
      // selected_product: function (newItem, oldItem) {
      //   this.resetOrderItem();
      // },
    }
  }

</script>
